import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { mockFAQs } from '../utils/mock';

export const FAQSection = () => {
  return (
    <section id="faqs" className="py-20 bg-[#FFF7ED]">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#7C2D12] mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-gray-600">
              Get answers to common questions about trademark registration and our services.
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-[#FED7AA]">
            <Accordion type="single" collapsible className="space-y-4">
              {mockFAQs.map((faq) => (
                <AccordionItem 
                  key={faq.id} 
                  value={`item-${faq.id}`}
                  className="border-b border-[#FED7AA] last:border-0"
                >
                  <AccordionTrigger className="text-left text-lg font-semibold text-[#7C2D12] hover:text-[#F97316] transition-colors py-4">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 leading-relaxed pb-4">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>

          {/* Contact CTA */}
          <div className="mt-12 text-center">
            <p className="text-gray-600 text-lg mb-4">
              Still have questions? Our trademark experts are here to help.
            </p>
            <p className="text-[#7C2D12] font-semibold text-xl">
              Call us at{' '}
              <a href="tel:+11231234567" className="text-[#F97316] hover:underline">
                +1 (123) 123-4567
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
